export type WalletWaitKind = 'idle' | 'wallet' | 'confirmation'

export type WalletWaitPresentation = {
  kind: WalletWaitKind
  waitPhase: 'awaiting-wallet' | 'awaiting-confirmation' | null
  canCancelWallet: boolean
}

/** Presentación de espera wallet genérica (swap, add/remove liquidez, approve). */
export function resolveWalletWaitPresentation(input: {
  attemptingTxn?: boolean
  walletProgressPhase?: 'wallet' | 'submitted' | null
  txHash?: string
  pendingOnChain?: boolean
}): WalletWaitPresentation {
  const { attemptingTxn = false, walletProgressPhase, txHash, pendingOnChain = false } = input

  if (txHash && pendingOnChain) {
    return {
      kind: 'confirmation',
      waitPhase: 'awaiting-confirmation',
      canCancelWallet: false,
    }
  }

  const awaitingSignature =
    attemptingTxn || walletProgressPhase === 'wallet' || walletProgressPhase === 'submitted'

  if (awaitingSignature && !txHash) {
    return {
      kind: 'wallet',
      waitPhase: 'awaiting-wallet',
      canCancelWallet: true,
    }
  }

  return { kind: 'idle', waitPhase: null, canCancelWallet: false }
}
